import { useMemo } from 'react';
import { TaskData, TaskStatus } from '../types/task';

interface TaskStats {
  incompletedCount:   number;
  thisWeekCount:      number;
  uniqueCompanyCount: number;
}

export function useTaskStats(tasks: TaskData[]): { stats: TaskStats } {
  const stats = useMemo<TaskStats>(() => {
    // 未完了：完了以外のカード数
    const incompletedCount = tasks
      .filter((t) => t.status !== TaskStatus.COMPLETED).length;

    // 今週の予定：tasks から計算（リアルタイム反映）
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
    const thisWeekCount = tasks.filter((t) => {
      if (t.status === TaskStatus.COMPLETED) return false;
      const due = new Date(t.due_date);
      return due >= today && due <= nextWeek;
    }).length;

    // 選考中：tasks から計算（リアルタイム反映）
    const uniqueCompanyCount = new Set(
      tasks
        .filter((t) => t.company_name && t.status !== TaskStatus.COMPLETED)
        .map((t) => t.company_name)
    ).size;

    return { incompletedCount, thisWeekCount, uniqueCompanyCount };
  }, [tasks]);

  return { stats };
}
